<template>
  <div class="me-container">
    <!-- <div class="header"></div> -->
    <el-image class="header" :src="info.backgroundImage" fit="cover">
      <div
        slot="error"
        style="
          height: 100%;
          background-color: #f5f7fa;
          font-size: 50px;
          display: flex;
          justify-content: center;
          align-items: center;
        "
      >
        <i class="el-icon-picture-outline"></i>
      </div>
    </el-image>
    <div class="content">
      <div class="avatar-row">
        <div class="avatar-box" :class="{ border: info.avatar }" @click="edit">
          <el-image v-if="info.avatar" :src="info.avatar" class="img" />
          <template v-else>
            <van-icon name="photograph" class="icon" />
            <div>添加头像</div>
          </template>
        </div>
        <div class="right">
          <div class="item">
            <div class="name">获赞</div>
            <div class="val">0</div>
          </div>
          <div class="item">
            <div class="name">关注</div>
            <div class="val">0</div>
          </div>
          <div class="item">
            <div class="name">粉丝</div>
            <div class="val">0</div>
          </div>
        </div>
      </div>
      <div class="bottom-content">
        <div class="nick-name" @click="edit">
          {{ info.name ? info.name : "点击填写名字" }}
        </div>
        <div class="info-content">
          <div class="no">抖音号：{{info.douyinNo}}</div>

          <div class="desc" @click="edit">
            {{ info.desc ? info.desc : "点击添加介绍，让大家认识你..." }}
          </div>
          <div class="tag-box">
            <div class="tag" v-if="info.birthday">{{ birthday }}岁</div>
            <div class="tag" v-if="info.city">{{ info.city }}</div>
            <div class="tag" v-if="info.school">{{ info.school }}</div>

            <div class="tag" @click="edit" v-if="addTags">
              添加{{ addTags }}标签
            </div>
          </div>

          <div class="btn-box">
            <div class="btn" @click="edit">编辑资料</div>
            <div class="btn">添加朋友</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Icon } from "vant";
export default {
  components: {
    [Icon.name]: Icon,
  },
  computed: {
    info() {
      return this.$store.state.simulation.douyinInfo;
    },
    birthday() {
      if (this.info.birthday) {
        const b = new Date(this.info.birthday);
        return new Date().getFullYear() - b.getFullYear();
      }
      return null;
    },
    addTags() {
      const { birthday, city, school } = this.info;
      const tags = [];
      if (!birthday) {
        tags.push("年龄");
      }
      if (!city) {
        tags.push("位置");
      }
      if (!school) {
        tags.push("学校");
      }

      if (tags.length > 2) {
        tags.length = 2;
        return tags.join("、") + "等";
      } else {
        return tags.join("、");
      }
    },
  },
  methods: {
    edit() {
      this.$router.push("info");
    },
  },
};
</script>
<style lang="less" scoped>
.me-container {
  height: 100%;

  .flex {
    display: flex;
    flex-direction: column;
  }
  .header {
    height: 100px;
    width: 100%;
  }

  .content {
    top: -10px;
    z-index: 10;
    position: relative;
    border-radius: 10px;
    background-color: #fff;

    .avatar-row {
      position: relative;
      top: -18px;
      margin: 0 12px;
      display: flex;

      .avatar-box {
        height: 80px;
        width: 80px;
        border-radius: 50%;
        background-color: rgba(88, 88, 88, 0.867);
        color: #fff;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        overflow: hidden;
        cursor: pointer;

        .icon {
          font-size: 24px;
        }

        &.border {
          border-width: 4px;
          border-style: solid;
          border-color: #fff;
        }

        .img {
          height: 100%;
          width: 100%;
        }
      }

      .right {
        flex: 1;
        display: flex;
        justify-content: space-around;
        align-items: center;
        .item {
          flex: 1;
          &:not(:last-child) {
            border-right-style: solid;
            border-right-width: 1px;
            border-color: #e2dfdf;
          }
          text-align: center;
          .name {
            font-size: 12px;
            color: #666666;
          }
          .val {
            font-weight: bold;
          }
        }
      }
    }

    .bottom-content {
      position: relative;
      top: -20px;
      .nick-name {
        margin: 0 6px;
        color: #999999;
        font-weight: bold;
        font-size: 24px;
        display: flex;
        align-items: center;
        cursor: pointer;
        &::before {
          content: "";
          display: inline-block;
          height: 60px;
          margin-right: 10px;
        }
      }

      .info-content {
        margin: 0 12px;
        .no {
          font-size: 12px;
          border-bottom-width: 1px;
          border-color: #e2dfdf;
          border-bottom-style: solid;
          padding-bottom: 10px;
        }

        .desc {
          color: #777777;
          margin-top: 16px;
          cursor: pointer;
        }

        .tag-box {
          margin-top: 4px;
          display: flex;

          .tag {
            font-size: 12px;
            padding: 4px;
            border-radius: 3px;
            background-color: #f0f0f0;
            cursor: pointer;

            &:not(:last-child) {
              margin-right: 6px;
            }
          }
        }

        .btn-box {
          margin-top: 10px;
          display: flex;
          justify-content: space-between;

          .btn {
            cursor: pointer;
            line-height: 30px;
            height: 30px;
            text-align: center;
            flex: 1;
            border-radius: 3px;
            background-color: #f0f0f0;
            &:first-child {
              margin-right: 6px;
            }
          }
        }
      }
    }
  }
}
</style>